module.exports = __webpack_public_path__ + "static/media/promptwatch.d18c9486.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/promptwatch.webp
// module id = 777
// module chunks = 0